import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import menuType from '../../constants/MenuType';
import { hideMenus, setContextTarget } from '../../actions/MenuActions';
import { uiProperties } from '../utils/TransformToolUtils';
import configuration from '../../constants/Configuration';
import shapeTypes from '../../constants/ShapeConstants';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import selectionManager from '../../components/utils/SelectionManager';
import hoverManager from '../utils/HoverManager';
import animationManager from '../utils/AnimationManager';
import locales from "../../locales/LocalesManager";
import textEditorUtils from './textEditorTool/utils/TextEditorUtils';

const ShapeMenuButtonContent = React.createClass({
    getInitialState () {
        return {
            isMenuButtonOver: false
        };
    },
    onMenuButtonMouseIn () {
        hoverManager.show(this.refs.shapeMenuButton, 'editShape');

        this.setState({
            isMenuButtonOver: true
        });
    },
    onMenuButtonMouseOut () {
        hoverManager.hide();

        this.setState({
            isMenuButtonOver: false
        });
    },
    onOpenMenu(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (platformDetection.isTouchableDevice() == true) {
            document.activeElement.blur();
        }

        if (!document.getElementById('htmlColorPicker'))
            e.preventDefault();

        textEditorUtils.closeTextEditor();

        const dispatch = this.props.dispatch;
        const shapeModel = this.getSelectedShape();
        dispatch(hideMenus([menuType.ALL_MENUS]));
        dispatch(setContextTarget(shapeModel));
    },
    getSelectedShape () {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;
        var target;

        if (!shapes)
            return target;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].isSelected == true) {
                target = shapes[i];
                break;
            }

        return target;
    },
    getShapePosition(shapeModel) {
        const scaleProperties = this.props.scaleProperties;
        var position = {left: 0, top: 0};
        const radius = uiProperties.RADIUS;
        const buttonSize = properties.SHAPE_MENU_BUTTON_SIZE;
        const scale = scaleProperties.scale;

        if (shapeModel.type == shapeTypes.LINE || shapeModel.type == shapeTypes.CURVE) {
            const position1 = {left: scaleProperties.topX + shapeModel.x1 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y1 * scale + radius / 2};
            const position2 = {left: scaleProperties.topX + shapeModel.x2 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y2 * scale + radius / 2};
            var opositePosition;

            const topLimit = scaleProperties.topY;
            const leftLimit = scaleProperties.topX;
            const rightLimit = leftLimit + configuration.CANVAS_WIDTH * scale;
            const bottomLimit = topLimit + configuration.CANVAS_HEIGHT * scale;

            if (shapeModel.x1 < shapeModel.x2) {
                position =  position2;
                opositePosition = position1;
            } else {
                position =  position1;
                opositePosition = position2;
            }

            if (position.left > rightLimit || position.left < leftLimit || position.top < topLimit || position.top > bottomLimit)
                position = opositePosition;

            return position;
        }

        //if (shapeModel.rotation > 0) {
        //    position.left = scaleProperties.topX  + (shapeModel.x  + shapeModel.width / 2) * scale - buttonSize / 2;
        //    position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height / 2) * scale - buttonSize / 2;
        //
        //    return position;
        //}

        var offset = 12;

        if (platformDetection.isIOS())
            offset = 20;

        if (shapeModel.width > configuration.CANVAS_WIDTH && shapeModel.height > configuration.CANVAS_HEIGHT) {
            position.left = scaleProperties.topX + configuration.CANVAS_WIDTH * scale - buttonSize;
            position.top = scaleProperties.topY;
        } else
        if (shapeModel.y < 0 && (shapeModel.y + shapeModel.height) > configuration.CANVAS_HEIGHT) {
            if ((shapeModel.x + shapeModel.width + buttonSize) > configuration.CANVAS_WIDTH) // move to TopLeft
                position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
            else
                position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scaleProperties.scale + offset;
        } else {
            if (shapeModel.y < 0 && (shapeModel.x + shapeModel.width + buttonSize) > configuration.CANVAS_WIDTH) { // move to BottomLeft
                position.left = scaleProperties.topX  + shapeModel.x * scale - buttonSize - offset;
                position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;

            } else if (shapeModel.y < 0) { // move to BottomRight
                position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
                position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;
            } else if ((shapeModel.x + shapeModel.width + buttonSize) > configuration.CANVAS_WIDTH) { // move to TopLeft
                position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
                position.top = scaleProperties.topY + shapeModel.y * scale + radius;
            } else { // move to TopRight (Normal)
                position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
                position.top = scaleProperties.topY + shapeModel.y * scale + radius;
            }
        }

        if (position.left < scaleProperties.topX)
            position.left = scaleProperties.topX + offset;

        if (position.left > scaleProperties.topX + configuration.CANVAS_WIDTH * scale - buttonSize - offset)
            position.left = scaleProperties.topX + configuration.CANVAS_WIDTH * scale - buttonSize - offset;

        if (position.top < scaleProperties.topY)
            position.top = scaleProperties.topY + offset;

        if (position.top > scaleProperties.topY + configuration.CANVAS_HEIGHT * scale - buttonSize - offset)
            position.top = scaleProperties.topY + configuration.CANVAS_HEIGHT * scale - buttonSize - offset;

        return position;
    },
    render() {
        const shapeModel = this.getSelectedShape();

        if (shapeModel == undefined || shapeModel.isInteraction == true || selectionManager.multipleSelection() == true || animationManager.clone)
            return (<div/>);

        var menuButtonFrameColor;

        if (this.state.isMenuButtonOver == true)
            menuButtonFrameColor = properties.SLIDE_FRAME_HOVER_COLOR;
        else
            menuButtonFrameColor = 'black';

        const position = this.getShapePosition(shapeModel);

        const menuButtonStyle = {
            position: 'absolute',
            top: position.top,
            left: position.left,
            width: properties.SLIDE_MENU_BUTTON_SIZE,
            height: properties.SLIDE_MENU_BUTTON_SIZE,
            background: 'white',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: menuButtonFrameColor,
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const menuButtonIconStyle = {
            position: 'absolute',
            top: 7,
            left: 9,
            color: menuButtonFrameColor
        };

        return (
            <button id='shapeMenuButton' className='menuButton' aria-label={locales.getCaption('editShape', 'hover')} style={menuButtonStyle} onTouchEnd={this.onOpenMenu} ref='shapeMenuButton' onClick={this.onOpenMenu} onMouseOver={this.onMenuButtonMouseIn} onMouseOut={this.onMenuButtonMouseOut}>
                <i style={menuButtonIconStyle} className="fa fa-bars menuButton"></i>
            </button>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const slideModel = state.currentSlide.model;

    return {
        slideModel
    };
}

export const ShapeMenuButton = connect(mapStateToProps)(ShapeMenuButtonContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ShapeMenuButton.js
 **/